<template>
    <div @click="load">
        <accordion-item>
                <h2 slot="header">
                    Bereavement Award &mdash; {{currencyFormat(value)}}
                </h2>
            <modal-content></modal-content>
        </accordion-item>
    </div>
</template>

<script>
    import ModalContent from 'components/modal/ModalContent';
    import AccordionItem from "components/accordion/AccordionItem";
    import {mapActions, mapGetters} from 'vuex';
    import currencyFormat from "mixins/currencyFormat";

    export default {
        name: "bereavement-award-modal",
        components: {
            AccordionItem,
            ModalContent
        },

        props: {
            person: {
                type: Object,
                required: true,
            },
            value: {
                required: true
            },
        },
        mixins: [
            currencyFormat
        ],
        created() {
            this.load();
        },
        methods: {
            ...mapActions('modal', ['getModalContent']),
            load() {
                this.getModalContent({
                    endpoint: 'dayOneBereavementAward',
                    payload: {
                        args: {person: this.person, claim: {type: 'fatal_accident_dependency'}}
                    }
                });
            },
        },
    }

</script>


// WEBPACK FOOTER //
// BereavementAwardModal.vue?7792a93d